import { useQuery } from '@apollo/client'

import { OrderRequirementChecksDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

import { useOrderId } from 'features/Orders/orders.hooks'

export const useChecksMinimums = () => {
  const orderId = useOrderId()
  const { data, loading } = useQuery(OrderRequirementChecksDocument, {
    client: atlasClient,
    variables: {
      orderIds: [orderId],
    },
    skip: !orderId,
  })

  return {
    areOrderMinimumsMet: Boolean(
      data?.orderRequirementChecks?.[0]?.checksMinimums,
    ),
    loadingCheckMinimums: loading,
  }
}
